import React from "react";

function AnalyzingIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        d="M20.6 22L17.9 19.3C17.5333 19.5167 17.15 19.6875 16.75 19.8125C16.35 19.9375 15.9333 20 15.5 20C14.25 20 13.1875 19.5625 12.3125 18.6875C11.4375 17.8125 11 16.75 11 15.5C11 14.25 11.4375 13.1875 12.3125 12.3125C13.1875 11.4375 14.25 11 15.5 11C16.75 11 17.8125 11.4375 18.6875 12.3125C19.5625 13.1875 20 14.25 20 15.5C20 15.9333 19.9375 16.35 19.8125 16.75C19.6875 17.15 19.5167 17.5333 19.3 17.9L22 20.6L20.6 22ZM17.275 17.275C17.7583 16.7917 18 16.2 18 15.5C18 14.8 17.7583 14.2083 17.275 13.725C16.7917 13.2417 16.2 13 15.5 13C14.8 13 14.2083 13.2417 13.725 13.725C13.2417 14.2083 13 14.8 13 15.5C13 16.2 13.2417 16.7917 13.725 17.275C14.2083 17.7583 14.8 18 15.5 18C16.2 18 16.7917 17.7583 17.275 17.275ZM21 10H19V5H17V8H7V5H5V19H10V21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.175C9.35833 2.41667 9.71667 1.9375 10.25 1.5625C10.7833 1.1875 11.3667 1 12 1C12.6667 1 13.2625 1.1875 13.7875 1.5625C14.3125 1.9375 14.6667 2.41667 14.85 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V10ZM12.7125 4.7125C12.9042 4.52083 13 4.28333 13 4C13 3.71667 12.9042 3.47917 12.7125 3.2875C12.5208 3.09583 12.2833 3 12 3C11.7167 3 11.4792 3.09583 11.2875 3.2875C11.0958 3.47917 11 3.71667 11 4C11 4.28333 11.0958 4.52083 11.2875 4.7125C11.4792 4.90417 11.7167 5 12 5C12.2833 5 12.5208 4.90417 12.7125 4.7125Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AnalyzingIcon;
